import React, { lazy, Suspense, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useNavigate, useParams, useLocation } from 'react-router-dom';
import { checkAutoLogin, isLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import Loader from './Loader';
import './other/swiper/css/swiper-bundle.min.css';
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { getToken } from './utils/ResuableFuncction';
import LoginScreens from './jsx/pages/LoginScreens';
import StudentRegister from './jsx/pages/StudentRegister';
import StudentForgotPassword from './jsx/pages/StudentForgotPassword';


// import TeacherLogin from './jsx/pages/TeacherLogin';
// import StudentLogin from './jsx/pages/StudentLogin';


const Index = lazy(() => import('./jsx/index'));
const SignUp = lazy(() => import('./jsx/pages/Registration'));
const Login = lazy(() => new Promise(resolve => setTimeout(() => resolve(import('./jsx/pages/Login')), 500)));
const TeacherLogin = lazy(() => new Promise(resolve => setTimeout(() => resolve(import('./jsx/pages/TeacherLogin')), 500)));
const StudentLogin = lazy(() => new Promise(resolve => setTimeout(() => resolve(import('./jsx/pages/StudentLogin')), 500)));
const StaffLogin = lazy(() => new Promise(resolve => setTimeout(() => resolve(import('./jsx/pages/StaffLogin')), 500)));


function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return <Component {...props} router={{ location, navigate, params }} />;
    }
    return ComponentWithRouterProp;
}

function App(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // useEffect(() => {
    //     checkAutoLogin(dispatch, navigate);
    // }, [dispatch, navigate]);

    let routeblog = (
        <Routes>
            <Route path='/' element={<LoginScreens />} />
            <Route path='/login' element={<Login />} />
            <Route path='/student/login' element={<StudentLogin />} />
            <Route path='/student/register' element={<StudentRegister />} />
            <Route path='/forgot-password' element={<StudentForgotPassword />} />
            <Route path='/teacher/login' element={<TeacherLogin />} />
            <Route path='/staff/login' element={<StaffLogin />} />
            <Route path='/page-register' element={<SignUp />} />
            {/* <Route path="/update-student/id" element={<UpdateStudent />} /> */}
        </Routes>
    );

    if (getToken()) {
           console.log("token rout executed")
        return (
                        // loader after the login page to inside application
            <Suspense fallback={
                <div id="preloader">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '20px' }}>
                       <Loader/>
                    </div>
                </div>
            }>
                <Index />
            </Suspense>
        );
    } else {
        console.log("Logn rout executed")
        return (
            // loader after the role selection to login page 
            <div className="vh-100">
                <Suspense fallback={
                      <div id="preloader">
                      <div className="d-flex justify-content-center align-items-center" style={{ height: '20px' }}>
                      <Loader/>
                      </div>
                  </div>
                }>   
                    {routeblog}
                </Suspense>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App));
